module.exports = __webpack_public_path__ + "img/ios2.png";